import styled from 'styled-components';
import { Icon } from '@gv/triage-components';

export const CheckIcon = styled(Icon.CheckCircle)`
  path {
    fill: ${({ theme }) => theme.colors.green.primary.standard};
  }
`;
